export const HTTPS_PROTOCOL = 'https://';

export const DEFAULT_IMG_PROXY_URL = 'https://img.nft-investment.io';

export const DEFAULT_CDN_BASE_URL = 'https://cdn.nft-investment.io';

export const MARKETPLACE_SEO_PATH = '/site/config/marketplaceSeoOpenGraph';

export const MARKETPLACE_FAVICON_PATH = '/site/config/marketplaceWebFavicon';

export const SEPARATOR = '||';
